import { Box, Stack } from "@mui/material";
import DeviceCredentialsCard from "./DeviceCredentialsCard";
import MqttConnectionCard from "./MqttConnectionCard";
import SecurityActionsCard from "./SecurityActionsCard";
import { useState } from "react";

export default function DeviceSettings({ deviceId }) {
  const [latestCredentials, setLatestCredentials] = useState(null);
  const [credentialRefreshKey, setCredentialRefreshKey] = useState(0);

  const handleRegenerated = (credentials) => {
    setLatestCredentials(credentials);
    setCredentialRefreshKey((prev) => prev + 1);
  };

  return (
    <Box sx={{ mt: 2 }}>
      <Stack spacing={2}>
        <DeviceCredentialsCard
          deviceId={deviceId}
          credentialRefreshKey={credentialRefreshKey}
        />
        <MqttConnectionCard
          deviceId={deviceId}
          credentialRefreshKey={credentialRefreshKey}
        />
        <SecurityActionsCard
          deviceId={deviceId}
          latestCredentials={latestCredentials}
          onRegenerated={handleRegenerated}
        />
        
      </Stack>
    </Box>
  );
}
